import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import './ui/styles.css';

import { useApp } from './ui/store';
// Exposed for automated browser tests and debugging.
import { KINDS } from './gameplay/registry';
(window as unknown as { __ea: typeof useApp }).__ea = useApp;
(window as unknown as { __kindKey: (i: number) => string }).__kindKey = (i) => KINDS[i]?.key;

createRoot(document.getElementById('root')!).render(<App />);
